// extracted by mini-css-extract-plugin
export default {"description":"style_description__CNQtg","fade-in":"style_fade-in__f+2LO","top":"style_top__rORVS","image":"style_image__LNJ0l"};